'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSafeValue;

var _regex = require('./utils/regex');

var dashRegex = /[ .]/g;
var percentRegex = /%/g;

/**
 * Makes the value safe for use in a class name.
 */
function getSafeValue(value) {
  return value.replace(dashRegex, '-').replace(percentRegex, 'prcnt').replace(_regex.unsafeClassNameCharacters, '');
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9nZXQtc2FmZS12YWx1ZS5qcyJdLCJuYW1lcyI6WyJnZXRTYWZlVmFsdWUiLCJkYXNoUmVnZXgiLCJwZXJjZW50UmVnZXgiLCJ2YWx1ZSIsInJlcGxhY2UiLCJ1bnNhZmVDbGFzc05hbWVDaGFyYWN0ZXJzIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFRd0JBLFk7O0FBUnhCOztBQUVBLElBQU1DLFlBQVksT0FBbEI7QUFDQSxJQUFNQyxlQUFlLElBQXJCOztBQUVBOzs7QUFHZSxTQUFTRixZQUFULENBQXNCRyxLQUF0QixFQUE2QjtBQUMxQyxTQUFPQSxNQUNKQyxPQURJLENBQ0lILFNBREosRUFDZSxHQURmLEVBRUpHLE9BRkksQ0FFSUYsWUFGSixFQUVrQixPQUZsQixFQUdKRSxPQUhJLENBR0lDLGdDQUhKLEVBRytCLEVBSC9CLENBQVA7QUFJRCIsImZpbGUiOiJnZXQtc2FmZS12YWx1ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7dW5zYWZlQ2xhc3NOYW1lQ2hhcmFjdGVyc30gZnJvbSAnLi91dGlscy9yZWdleCdcblxuY29uc3QgZGFzaFJlZ2V4ID0gL1sgLl0vZ1xuY29uc3QgcGVyY2VudFJlZ2V4ID0gLyUvZ1xuXG4vKipcbiAqIE1ha2VzIHRoZSB2YWx1ZSBzYWZlIGZvciB1c2UgaW4gYSBjbGFzcyBuYW1lLlxuICovXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRTYWZlVmFsdWUodmFsdWUpIHtcbiAgcmV0dXJuIHZhbHVlXG4gICAgLnJlcGxhY2UoZGFzaFJlZ2V4LCAnLScpXG4gICAgLnJlcGxhY2UocGVyY2VudFJlZ2V4LCAncHJjbnQnKVxuICAgIC5yZXBsYWNlKHVuc2FmZUNsYXNzTmFtZUNoYXJhY3RlcnMsICcnKVxufVxuIl19